/*! For license information please see q10v_main.js.LICENSE.txt */ ! function() {
    var s = {
            "./src/js/main.js": function(s, e, t) {
                "use strict";
                t("jquery");
                (0, t("./src/widgets/debug.js").debugfunction)();
                document.documentElement.clientHeight || window.innerHeight;
                var i = (document.documentElement.clientWidth || window.innerWidth) < 750,
                    n = $(window).scrollTop(),
                    c = null,
                    o = null;

                function r() {
                    var s = document.querySelectorAll($.CN(".section-sixth .list-item .item-line"));
                    s && s.forEach((function(s, e) {
                        var t = s;
                        ScrollTrigger.create({
                            trigger: t,
                            start: "bottom bottom-=20%",
                            end: "bottom bottom-=20%",
                            onEnter: function(s) {
                                $(s.trigger).addClass("".concat("q10v_", "active"))
                            },
                            onLeaveBack: function(s) {
                                $(s.trigger).removeClass("".concat("q10v_", "active"))
                            },
                            invalidateOnRefresh: !0,
                            scrub: .3,
                            snap: {
                                ease: "power1.out"
                            }
                        })
                    }))
                }
                $(window).on("scroll", (function(s) {
                    var e = $(window).scrollTop();
                    if (n = e, $($.CN(".product-container .section")).each((function(s, e) {
                            var t, i = $(e).data("section"),
                                r = e.offsetTop,
                                a = r + e.offsetHeight;
                            n <= r || n >= a || (n >= r && n <= a && (c = i, o = $(e).find($.CN(".video-main"))), 1 === i || 2 === i && ((t = e.getBoundingClientRect()).top, t.right, t.bottom, t.left))
                        })), i) {
                        [2].includes(c) && o.each((function(s) {
                            var e;
                            (e = $(this), new Promise((function(s, t) {
                                e.paused ? e.play().then((function() {
                                    s()
                                })).catch((function(s) {
                                    t(s)
                                })) : s()
                            }))).then((function() {
                                console.log("视频正在播放")
                            })).catch((function(s) {
                                console.error("播放视频时出错", s)
                            }))
                        }))
                    }
                })), $(window).on("resize", (function(s) {})), $(document).ready((function() {
                    $($.CN(".fadein-up")).each((function() {
                        gsap.set($(this), {
                            opacity: 0,
                            y: 40
                        }), gsap.fromTo($(this), {
                            y: 40,
                            opacity: 0
                        }, {
                            y: 0,
                            opacity: 1,
                            duration: .5,
                            ease: "power2.easeOut",
                            immediateRender: !0,
                            scrollTrigger: {
                                trigger: $(this),
                                start: "top center",
                                end: "top+=50px center",
                                invalidateOnRefresh: !0,
                                toggleActions: "play none reverse none"
                            },
                            delay: Number($(this).attr("delay")) || 0
                        })
                    })), $($.CN(".container-fadein-up-list")).each((function() {
                        $(this).attr("start");
                        var s = gsap.timeline({
                            scrollTrigger: {
                                trigger: $(this),
                                start: "top-=10% center-=20%",
                                end: "top+=50px center",
                                invalidateOnRefresh: !0,
                                toggleActions: "play none reverse none"
                            },
                            onComplete: function() {
                                ScrollTrigger.refresh()
                            }
                        });
                        $(this).find($.CN(".fadein-up-list")).each((function(e, t) {
                            gsap.set($(t), {
                                opacity: 0,
                                y: 30
                            }), s.fromTo($(t), {
                                y: 30,
                                opacity: 0
                            }, {
                                y: 0,
                                opacity: 1,
                                duration: .5,
                                ease: "power0.easeOut",
                                immediateRender: !0
                            }, "<40%")
                        }))
                    }))
                })), window.onload = function() {
                    $($.CN(".section-first .fadeLoad-up")).addClass("".concat("q10v_", "active")),
                        // function() {
                        //     var s = document.querySelector($.CN(".section-third .boxHover")),
                        //         e = s.querySelectorAll($.CN(".section-third .boxHover .box-content-img")),
                        //         t = s.querySelectorAll($.CN(".section-third .boxHover .box-prodect-text .p-text"));

                        //     function n(s, e, t) {
                        //         s.forEach((function(s) {
                        //             return s.classList.remove("".concat("q10v_", "active"))
                        //         })), s[t].classList.add("".concat("q10v_", "active")), e.forEach((function(s) {
                        //             return s.classList.remove("".concat("q10v_", "active"))
                        //         })), e[t].classList.add("".concat("q10v_", "active"))
                        //     }
                        //     s && (i || (s.addEventListener("mouseenter", (function() {
                        //         n(t, e, 1)
                        //     })), s.addEventListener("mouseleave", (function() {
                        //         n(t, e, 0)
                        //     }))), t.forEach((function(s, i) {
                        //         s.addEventListener("click", (function() {
                        //             n(t, e, i)
                        //         }))
                        //     })))
                        // }(),
                        function(s) {
                            var e = $.CN(".section-fifth .number-text .number"),
                                t = $.CN(".section-fifth .number-text");
                            if (e) {
                                var i = $(e).attr("panumber");
                                i = parseInt(i.replace(/,|\./g, ""), 10), ScrollTrigger.create({
                                    trigger: t,
                                    start: "top bottom-=35%",
                                    end: "bottom bottom-=25%",
                                    onEnter: function() {
                                        $(e).text(0), gsap.to(e, 1.2, {
                                            onUpdate: function() {
                                                var s = Math.round(this.progress() * i);
                                                s = s.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), $(e).text(s)
                                            }
                                        })
                                    },
                                    onEnterBack: function() {
                                        $(e).text(0)
                                    },
                                    scrub: .3,
                                    invalidateOnRefresh: !0,
                                    id: "s5-num"
                                })
                            }
                        }(), r(),
                        function() {
                            $($.CN(".section-eleventh .content-swiper")) && i && new Swiper("#eleventhSwiper", {
                                grabCursor: !0,
                                effect: "slide",
                                speed: 600,
                                easing: "ease-out",
                                loop: !0,
                                slidesPerView: "auto",
                                a11y: {
                                    slideRole: "listitem"
                                },
                                autoplay: !1,
                                navigation: {},
                                on: {
                                    slideChange: function() {}
                                }
                            }).slideTo(0);
                            var s = document.querySelectorAll($.CN(".section-eleventh .list-item"));
                            if (s)
                                if (i) {
                                    var e = document.querySelectorAll($.CN(".section-eleventh .list-item-box")),
                                        t = document.querySelectorAll($.CN(".section-eleventh .list-item-boxmask"));
                                    e.forEach((function(e, t) {
                                        e.addEventListener("click", (function() {
                                            console.log(333), s.forEach((function(s) {
                                                return s.classList.remove("".concat("q10v_", "active"))
                                            })), s[t].classList.add("".concat("q10v_", "active"))
                                        }))
                                    })), t.forEach((function(e, t) {
                                        e.addEventListener("click", (function() {
                                            console.log(111), s.forEach((function(s) {
                                                return s.classList.remove("".concat("q10v_", "active"))
                                            }))
                                        }))
                                    }))
                                } else s.forEach((function(e, t) {
                                    e.addEventListener("mouseenter", (function() {
                                        s.forEach((function(s) {
                                            return s.classList.remove("".concat("q10v_", "active"))
                                        })), s[t].classList.add("".concat("q10v_", "active"))
                                    })), e.addEventListener("mouseleave", (function() {
                                        s.forEach((function(s) {
                                            return s.classList.remove("".concat("q10v_", "active"))
                                        }))
                                    }))
                                }))
                        }()
                }
            },
            "./src/widgets/ClassExtension.js": function() {
                ! function(s) {
                    s.extend({
                        CN: function(s) {
                            return s.startsWith(".") ? s.split(" ").map((function(s) {
                                return s.startsWith(".") ? ".".concat("q10v_").concat(s.slice(1)) : s
                            })).join(" ") : "q10v_" + s
                        }
                    })
                }($)
            },
            "./src/widgets/FullScreenVideo/index.js": function(s, e, t) {
                "use strict";
                $((function() {
                    function s() {
                        $($.CN(".full_screen_video")).hide();
                        var s = new window.CustomEvent("hide.all.modals");
                        document.dispatchEvent(s)
                    }! function() {
                        var s = document.querySelectorAll($.CN(".as-youtube-video"));
                        if (s.length > 0) {
                            var e = document.createElement("script");
                            e.src = "https://www.youtube.com/iframe_api";
                            var t = document.getElementsByTagName("script")[0];
                            t.parentNode.insertBefore(e, t);
                            var i = [],
                                n = function(s) {
                                    document.addEventListener("hide.all.modals", (function(s) {
                                        for (var e = 0; e < i.length; e++) i[e].pauseVideo()
                                    }))
                                };
                            window.onYouTubeIframeAPIReady = function() {
                                for (var e = 0; e < s.length; e++) i.push(new window.YT.Player(s[e], {
                                    events: {
                                        onReady: n
                                    }
                                }))
                            }
                        }
                    }(), $($.CN(".section-second .video-box .videoBtn")).on("click", (function(s) {
                        console.log("videoBtn"), $($.CN(".full_screen_video")).show()
                    })), $($.CN(".full_screen_video")).on("click", (function(e) {
                        s()
                    })), $($.CN(".full_screen_video .video-close")).on("click", (function(e) {
                        s()
                    }))
                }))
            },
            "./src/widgets/SeriseContainer/index.js": function() {
                "use strict";
                $((function() {
                    $("#sideBtn").on("click", (function() {
                        var s = $($.CN(".serise-container"));
                        s.hasClass($.CN("show")) ? s.addClass($.CN("hide")).removeClass($.CN("show")) : s.addClass($.CN("show")).removeClass($.CN("hide"))
                    })), $("#popup-tab").delegate($.CN(".tabTitle"), "click", (function(s) {
                        $(this).addClass($.CN("active")).siblings().removeClass($.CN("active")), $($.CN(".tabbody .tabCard")).eq($(this).index()).show().siblings().hide(), $($.CN(".pc .img")).eq($(this).index()).addClass($.CN("active")).siblings().removeClass($.CN("active")), $($.CN(".mob .img")).eq($(this).index()).addClass($.CN("active")).siblings().removeClass($.CN("active"))
                    }))
                }))
            },
            "./src/widgets/basics.js": function(s, e, t) {
                "use strict";

                function i() {
                    $(".ad-bar").length > 0 && $($.CN(".container")).css({
                        "margin-top": "110px"
                    }), $("#product_subscription_b").on("click", (function() {
                        $("#subscribe-modal").css({
                            display: "block"
                        })
                    }))
                }
                t.d(e, {
                    basics: function() {
                        return i
                    }
                })
            },
            "./src/widgets/debug.js": function(s, e, t) {
                "use strict";

                function i() {
                    var s, e, t, i, n, c, o, r, a = null,
                        p = !1,
                        l = null,
                        g = null,
                        u = null,
                        _ = null;

                    function d() {
                        var s = window.innerWidth,
                            e = window.innerHeight;
                        window.outerWidth, window.outerHeight;
                        a && (a.text("分辨率".concat(s, "*").concat(e)), window.innerWidth > 751 ? ($(l).css("display", "block"), $(g).css("display", "block"), $(u).css("display", "block"), $(_).css("display", "block")) : ($(l).css("display", "none"), $(g).css("display", "none"), $(u).css("display", "none"), $(_).css("display", "none")))
                    }
                    // s = window.location.href, e = new URL(s), t = e.hostname, i = e.searchParams.get("debugResolution"), !(n = /^((25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)$/).test(t) && !/^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|(([0-9a-fA-F]{1,4}:){1,7}|:):(([0-9a-fA-F]{1,4}:){1,7}|:))$/.test(t) && "show" != i || (p || function() {
                    //     (a = $("<div>", {
                    //         id: "resolution-container",
                    //         style: "position:fixed;top:10px;left:10px;z-index:9999999;background-color:rgba(0,0,0,0.6);color:#fff;padding:5px 10px;box-shadow:0 0 10px rgba(0,0,0,0.1);",
                    //         text: "分辨率: 加载中..."
                    //     })).appendTo("body"), p = !0, l = $("<div>", {
                    //         id: "resolution-choose-Title",
                    //         style: "position:fixed;top:10px;left:263px;z-index:9999999;color:#000;padding:5px 10px;",
                    //         text: " 分辨率大小按钮=>"
                    //     }), g = $("<a>", {
                    //         id: "resolution-choose1",
                    //         style: "position:fixed;top:10px;left:405px;z-index:9999999;background-color:rgba(0,0,0,0.6);color:#fff;padding:5px 10px;box-shadow:0 0 10px rgba(0,0,0,0.1);border-radius:20px;cursor: pointer;",
                    //         text: "1920*960"
                    //     }), u = $("<a>", {
                    //         id: "resolution-choose2",
                    //         style: "position:fixed;top:10px;left:500px;z-index:9999999;background-color:rgba(0,0,0,0.6);color:#fff;padding:5px 10px;box-shadow:0 0 10px rgba(0,0,0,0.1);border-radius:20px;cursor: pointer;",
                    //         text: "1536*754"
                    //     }), _ = $("<a>", {
                    //         id: "resolution-choose3",
                    //         style: "position:fixed;top:10px;left:592px;z-index:9999999;background-color:rgba(0,0,0,0.6);color:#fff;padding:5px 10px;box-shadow:0 0 10px rgba(0,0,0,0.1);border-radius:20px;cursor: pointer;",
                    //         text: "1280*600"
                    //     }), l.appendTo("body"), g.appendTo("body"), u.appendTo("body"), _.appendTo("body");
                    //     var s = window.location.href;
                    //     g.on("click", (function() {
                    //         window.open(s, "_blank", "width=1920,height=961")
                    //     })), u.on("click", (function() {
                    //         window.open(s, "_blank", "width=1536,height=755")
                    //     })), _.on("click", (function() {
                    //         window.open(s, "_blank", "width=1280,height=601")
                    //     }))
                    // }(), d(), n.test(t)), $(window).resize((c = d, o = 200, r = 0, function() {
                    //     var s = (new Date).getTime();
                    //     s - r >= o && (r = s, c.apply(void 0, arguments))
                    // }))
                }
                t.d(e, {
                    debugfunction: function() {
                        return i
                    }
                })
            },
            "./src/widgets/index.js": function(s, e, t) {
                "use strict";
                t("./src/widgets/FullScreenVideo/index.js"), t("./src/widgets/SeriseContainer/index.js"), t("./src/widgets/ClassExtension.js");
                (0, t("./src/widgets/basics.js").basics)()
            },
            "./src/index.html": function(s, e, t) {
                "use strict";
                var i = t("./node_modules/html-loader/dist/runtime/getUrl.js"),
                    n = t.n(i),
                    c = new URL(t("./src/assets/images/section1_KV_m.jpg"), t.b),
                    o = new URL(t("./src/assets/images/section1_KV.jpg"), t.b),
                    r = new URL(t("./src/assets/images/section3_point.png"), t.b),
                    a = new URL(t("./src/assets/images/section3_pic1_m.jpg"), t.b),
                    p = new URL(t("./src/assets/images/section3_pic1.jpg"), t.b),
                    l = new URL(t("./src/assets/images/section3_pic2_m.jpg"), t.b),
                    g = new URL(t("./src/assets/images/section3_pic2.jpg"), t.b),
                    u = new URL(t("./src/assets/images/section3_pic4_m.jpg"), t.b),
                    _ = new URL(t("./src/assets/images/section3_pic4.jpg"), t.b),
                    d = new URL(t("./src/assets/images/section3_pic5_m.jpg"), t.b),
                    f = new URL(t("./src/assets/images/section3_pic5.jpg"), t.b),
                    m = new URL(t("./src/assets/images/section3_pic6_m.jpg"), t.b),
                    b = new URL(t("./src/assets/images/section3_pic6.jpg"), t.b),
                    x = new URL(t("./src/assets/images/section3_pic7_m.jpg"), t.b),
                    j = new URL(t("./src/assets/images/section3_pic7.jpg"), t.b),
                    w = new URL(t("./src/assets/images/section5_10000pa_m.png"), t.b),
                    h = new URL(t("./src/assets/images/section5_10000pa.png"), t.b),
                    v = new URL(t("./src/assets/images/section5_background_m.jpg"), t.b),
                    $ = new URL(t("./src/assets/images/section5_background.jpg"), t.b),
                    L = new URL(t("./src/assets/images/section5_pic_m.jpg"), t.b),
                    C = new URL(t("./src/assets/images/section5_pic.jpg"), t.b),
                    R = new URL(t("./src/assets/images/section6_Less_m.jpg"), t.b),
                    y = new URL(t("./src/assets/images/section6_Less.jpg"), t.b),
                    U = new URL(t("./src/assets/images/section6_utv.png"), t.b),
                    N = new URL(t("./src/assets/images/section7_Carpet1_m.jpg"), t.b),
                    k = new URL(t("./src/assets/images/section7_Carpet1.jpg"), t.b),
                    E = new URL(t("./src/assets/images/section7_Carpet2_m.jpg"), t.b),
                    T = new URL(t("./src/assets/images/section7_Carpet2.jpg"), t.b),
                    A = new URL(t("./src/assets/images/section8_bg_m.png"), t.b),
                    S = new URL(t("./src/assets/images/section8_bg.png"), t.b),
                    q = new URL(t("./src/assets/images/section8_Reactive_m.jpg"), t.b),
                    D = new URL(t("./src/assets/images/section8_Reactive.jpg"), t.b),
                    P = new URL(t("./src/assets/images/section9_LiDAR_m.jpg"), t.b),
                    V = new URL(t("./src/assets/images/section9_LiDAR.jpg"), t.b),
                    B = new URL(t("./src/assets/images/section9_pic.jpg"), t.b),
                    O = new URL(t("./src/assets/images/section10_Dock_m.png"), t.b),
                    H = new URL(t("./src/assets/images/section10_Dock.png"), t.b),
                    z = new URL(t("./src/assets/images/section10_logo.png"), t.b),
                    W = new URL(t("./src/assets/images/section10_Phone_m.jpg"), t.b),
                    F = new URL(t("./src/assets/images/section10_Phone.jpg"), t.b),
                    K = new URL(t("./src/assets/images/section11_pic1.jpg"), t.b),
                    I = new URL(t("./src/assets/images/section11_pic2.jpg"), t.b),
                    M = new URL(t("./src/assets/images/section11_pic3.jpg"), t.b),
                    Y = new URL(t("./src/assets/images/section11_pic4.jpg"), t.b);
                n()(c), n()(o), n()(r), n()(a), n()(p), n()(l), n()(g), n()(u), n()(_), n()(d), n()(f), n()(m), n()(b), n()(x), n()(j), n()(w), n()(h), n()(v), n()($), n()(L), n()(C), n()(R), n()(y), n()(U), n()(N), n()(k), n()(E), n()(T), n()(A), n()(S), n()(q), n()(D), n()(P), n()(V), n()(B), n()(O), n()(H), n()(z), n()(W), n()(F), n()(K), n()(I), n()(M), n()(Y)
            },
            "./node_modules/html-loader/dist/runtime/getUrl.js": function(s) {
                "use strict";
                s.exports = function(s, e) {
                    return e || (e = {}), s ? (s = String(s.__esModule ? s.default : s), e.hash && (s += e.hash), e.maybeNeedQuotes && /[\t\n\f\r "'=<>`]/.test(s) ? '"'.concat(s, '"') : s) : s
                }
            },
            "./src/assets/images/section10_Dock.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section10_Dock.png"
            },
            "./src/assets/images/section10_Dock_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section10_Dock_m.png"
            },
            "./src/assets/images/section10_Phone.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section10_Phone.jpg"
            },
            "./src/assets/images/section10_Phone_m.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section10_Phone_m.jpg"
            },
            "./src/assets/images/section10_logo.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section10_logo.png"
            },
            "./src/assets/images/section11_pic1.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section11_pic1.jpg"
            },
            "./src/assets/images/section11_pic2.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section11_pic2.jpg"
            },
            "./src/assets/images/section11_pic3.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section11_pic3.jpg"
            },
            "./src/assets/images/section11_pic4.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section11_pic4.jpg"
            },
            "./src/assets/images/section1_KV.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section1_KV.jpg"
            },
            "./src/assets/images/section1_KV_m.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section1_KV_m.jpg"
            },
            "./src/assets/images/section3_pic1.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section3_pic1.jpg"
            },
            "./src/assets/images/section3_pic1_m.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section3_pic1_m.jpg"
            },
            "./src/assets/images/section3_pic2.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section3_pic2.jpg"
            },
            "./src/assets/images/section3_pic2_m.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section3_pic2_m.jpg"
            },
            "./src/assets/images/section3_pic4.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section3_pic4.jpg"
            },
            "./src/assets/images/section3_pic4_m.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section3_pic4_m.jpg"
            },
            "./src/assets/images/section3_pic5.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section3_pic5.jpg"
            },
            "./src/assets/images/section3_pic5_m.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section3_pic5_m.jpg"
            },
            "./src/assets/images/section3_pic6.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section3_pic6.jpg"
            },
            "./src/assets/images/section3_pic6_m.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section3_pic6_m.jpg"
            },
            "./src/assets/images/section3_pic7.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section3_pic7.jpg"
            },
            "./src/assets/images/section3_pic7_m.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section3_pic7_m.jpg"
            },
            "./src/assets/images/section3_point.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section3_point.png"
            },
            "./src/assets/images/section5_10000pa.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section5_10000pa.png"
            },
            "./src/assets/images/section5_10000pa_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section5_10000pa_m.png"
            },
            "./src/assets/images/section5_background.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section5_background.jpg"
            },
            "./src/assets/images/section5_background_m.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section5_background_m.jpg"
            },
            "./src/assets/images/section5_pic.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section5_pic.jpg"
            },
            "./src/assets/images/section5_pic_m.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section5_pic_m.jpg"
            },
            "./src/assets/images/section6_Less.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section6_Less.jpg"
            },
            "./src/assets/images/section6_Less_m.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section6_Less_m.jpg"
            },
            "./src/assets/images/section6_utv.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section6_utv.png"
            },
            "./src/assets/images/section7_Carpet1.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section7_Carpet1.jpg"
            },
            "./src/assets/images/section7_Carpet1_m.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section7_Carpet1_m.jpg"
            },
            "./src/assets/images/section7_Carpet2.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section7_Carpet2.jpg"
            },
            "./src/assets/images/section7_Carpet2_m.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section7_Carpet2_m.jpg"
            },
            "./src/assets/images/section8_Reactive.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section8_Reactive.jpg"
            },
            "./src/assets/images/section8_Reactive_m.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section8_Reactive_m.jpg"
            },
            "./src/assets/images/section8_bg.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section8_bg.png"
            },
            "./src/assets/images/section8_bg_m.png": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section8_bg_m.png"
            },
            "./src/assets/images/section9_LiDAR.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section9_LiDAR.jpg"
            },
            "./src/assets/images/section9_LiDAR_m.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section9_LiDAR_m.jpg"
            },
            "./src/assets/images/section9_pic.jpg": function(s, e, t) {
                "use strict";
                s.exports = t.p + "files/q10v_section9_pic.jpg"
            },
            jquery: function(s) {
                "use strict";
                s.exports = $
            }
        },
        e = {};

    function t(i) {
        var n = e[i];
        if (void 0 !== n) return n.exports;
        var c = e[i] = {
            exports: {}
        };
        return s[i](c, c.exports, t), c.exports
    }
    t.m = s, t.n = function(s) {
            var e = s && s.__esModule ? function() {
                return s.default
            } : function() {
                return s
            };
            return t.d(e, {
                a: e
            }), e
        }, t.d = function(s, e) {
            for (var i in e) t.o(e, i) && !t.o(s, i) && Object.defineProperty(s, i, {
                enumerable: !0,
                get: e[i]
            })
        }, t.o = function(s, e) {
            return Object.prototype.hasOwnProperty.call(s, e)
        }, t.p = "/cdn/shop/", t.b = document.baseURI || self.location.href,
        function() {
            "use strict";
            t("./src/index.html"), t("./src/widgets/index.js"), t("./src/js/main.js")
        }()
}();